// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import timeSheetDateRangeReducer from './slices/timeSheetDateRangeSlice';
import organisationDetailsReducer from './slices/organisationDetailsSlice';
import notificationsReducer from './slices/notificationsSlice';


const store = configureStore({
  reducer: {
    organisationDetails: organisationDetailsReducer,
    timeSheetDateRange: timeSheetDateRangeReducer,
    notifications: notificationsReducer
  },
  // Middleware and other settings can go here if needed
});

export default store;
